export default {
    "changsheng": {
        "text": ["长生", "沐浴", "冠带", "临官", "帝旺", "衰", "病", "死", "墓", "绝", "胎", "养"],
        "gan": [
            "亥子丑寅卯辰巳午未申酉戌",
            "午巳辰卯寅丑子亥戌酉申未",
            "寅卯辰巳午未申酉戌亥子丑",
            "酉申未午巳辰卯寅丑子亥戌",
            "寅卯辰巳午未申酉戌亥子丑",
            "酉申未午巳辰卯寅丑子亥戌",
            "巳午未申酉戌亥子丑寅卯辰",
            "子亥戌酉申未午巳辰卯寅丑",
            "申酉戌亥子丑寅卯辰巳午未",
            "卯寅丑子亥戌酉申未午巳辰"
        ],
    },
    "nianrigan": {
        "text": "甲乙丙丁戊己庚辛壬癸",
        "classify": {
            "taijiguiren": {
                "text": "太极贵人",
                "duizhao": ["子午", "子午", "卯酉", "卯酉", "辰戌丑未", "辰戌丑未", "寅亥", "寅亥", "巳申", "巳申"]
            },
            "fuxingguiren": {
                "text": "福星贵人",
                "duizhao": ['寅子', '卯丑', '寅子', '亥', '申', '未', '午', '巳', '辰', '卯丑'],
            },
            "tianchuguiren": {
                "text": "天厨贵人",
                "duizhao": "巳午巳午申酉亥子寅卯"
            },
            "guoyinguiren": {
                "text": "国印贵人",
                "duizhao": "戌亥丑寅丑寅辰巳未申"
            },
        }
    },
    "yuezhi": {
        "text": "寅卯辰巳午未申酉戌亥子丑",
        "classify": {
            "tiandeguiren": {
                "text": "天德贵人",
                "duizhao": "丁申壬辛亥甲癸寅丙乙巳庚"
            },
            "tiandehe": {
                "text": "天德合",
                "duizhao": "壬巳丁丙寅己戊亥辛庚申乙"
            },
            "yuedeguiren": {
                "text": "月德贵人",
                "duizhao": "丙甲壬庚丙甲壬庚丙甲壬庚"
            },
            "yuedehe": {
                "text": "月德合",
                "duizhao": "辛己丁乙辛己丁乙辛己丁乙"
            },
            "tianyixing": {
                "text": "天医",
                "duizhao": "丑寅卯辰巳午未申酉戌亥子"
            },
            "wugui": {
                "text": "五鬼",
                "duizhao": "午未申酉戌亥子丑寅卯辰巳"
            },
            "xueren": {
                "text": "血刃",
                "duizhao": "丑未寅申卯酉辰戌巳亥午子"
            },
            "tianshe": {
                "text": "天赦",
                "duizhao": ['戊寅', '戊寅', '戊寅', '甲午', '甲午', '甲午', '戊申', '戊申', '戊申', '甲子', '甲子', '甲子']
            },
        }
    },
    "rigan": {
        "text": "甲乙丙丁戊己庚辛壬癸",
        "classify": {
            "tianyiguiren": {
                "text": "天乙贵人",
                "duizhao": ["丑未", "子申", "亥酉", "亥酉", "丑未", "子申", "寅午", "寅午", "卯巳", "卯巳"]
            },
            "wenchangxing": {
                "text": "文昌",
                "duizhao": "巳午申酉申酉亥子寅卯"
            },
            "shiganlushen": {
                "text": "禄神", //日禄
                "duizhao": "寅卯巳午巳午申酉亥子"
            },
            "yangren": {
                "text": "羊刃",
                "duizhao": "卯寅午巳午巳酉申子亥"
            },
            "feiren": {
                "text": "飞刃",
                "duizhao": "酉申子亥子亥卯寅午巳"
            },
            "hongyansha": {
                "text": "红艳煞",
                "duizhao": "午申寅未辰辰戌酉子申"
            },
            "jinyuxing": {
                "text": "金舆",
                "duizhao": "辰巳未申未申戌亥丑寅"
            },
            "liuxia": {
                "text": "流霞",
                "duizhao": "酉戌未申巳午辰卯亥寅"
            },
            "shuinisha": {
                "text": "水溺煞",
                "duizhao": ["", "", "子", "", "", "", "", "", "", "未丑"]
            }
        }
    },
    "nianrizhi": {
        "text": "子丑寅卯辰巳午未申酉戌亥",
        "classify": {
            "jiangxing": {
                "text": "将星",
                "duizhao": "子酉午卯子酉午卯子酉午卯"
            },
            "huagaixing": {
                "text": "华盖",
                "duizhao": "辰丑戌未辰丑戌未辰丑戌未"
            },
            "yima": {
                "text": "驿马",
                "duizhao": "寅亥申巳寅亥申巳寅亥申巳"
            },
            "taohua": {
                "text": "桃花(咸池)",
                "duizhao": "酉午卯子酉午卯子酉午卯子"
            },
            "guchen": {
                "text": "孤辰",
                "duizhao": "寅寅巳巳巳申申申亥亥亥寅"
            },
            "guasu": {
                "text": "寡宿",
                "duizhao": "戌戌丑丑丑辰辰辰未未未戌"
            },
            "hongluan": {
                "text": "红鸾",
                "duizhao": "卯寅丑子亥戌酉申未午巳辰"
            },
            "tianxi": {
                "text": "天禧",
                "duizhao": "酉申未午巳辰卯寅丑子亥戌"
            },
            "jiesha": {
                "text": "劫煞",
                "duizhao": "巳寅亥申巳寅亥申巳寅亥申"
            },
            "wangshen": {
                "text": "亡神",
                "duizhao": "亥申巳寅亥申巳寅亥申巳寅"
            }
        }
    },
    "nianzhi": {
        "text": "子丑寅卯辰巳午未申酉戌亥",
        "classify": {
            "zaisha": {
                "text": "灾煞",
                "duizhao": "午卯子酉午卯子酉午卯子酉"
            },
            "sangmen": {
                "text": "丧门",
                "duizhao": "寅卯辰巳午未申酉戌亥子丑"
            },
            "diaoke": {
                "text": "吊客",
                "duizhao": "戌亥子丑寅卯辰巳午未申酉"
            },
            "bingfu": {
                "text": "病符",
                "duizhao": "亥子丑寅卯辰巳午未申酉戌"
            },
            "dahao": {
                "text": "大耗",
                "duizhao": "午未申酉戌亥子丑寅卯辰巳"
            },
            "ziyisha": {
                "text": "自缢煞",
                "duizhao": "酉午未申亥戌丑寅卯子巳辰"
            },
            "goujiao": {
                "text": "勾绞",
                "duizhao1": "卯辰巳午未申酉戌亥子丑寅", //阳男阴女勾 / 阴男阳女绞
                "duizhao2": "酉戌亥子丑寅卯辰巳午未申", //阳男阴女绞 / 阴男阳女勾
            },
            "baihu": {
                "text": "白虎",
                "duizhao": "午卯子酉午卯子酉午卯子酉"
            }

        }
    },
    "rizhi": {
        "classify": {
            "tianluo": {
                "text": "天罗",
                "rizhi": "戌亥",
                "duizhao": "亥戌"
            },
            "diwang": {
                "text": "地网",
                "rizhi": "辰巳",
                "duizhao": "巳辰"
            }
        }
    },
    "rishizhi": {
        "text": "子丑寅卯辰巳午未申酉戌亥",
        "classify": {
            "gejiao": {
                "text": "隔角",
                "duizhao": "寅卯辰巳午未申酉戌亥子丑"
            },
        }
    },
    "riganother": {
        "classify": {
            "jielukongwang": {
                "text": "截路空亡",
                "rigan": ["甲己", "乙庚", "丙辛", "丁壬", "戊癸"],
                "duizhao": ["申酉", "午未", "辰巳", "寅卯", "子丑"]
            }
        }
    },
    "rizhu": {
        "classify": {
            "liuxiu": {
                "text": "六秀日",
                "duizhao": ["丙午", "丁未", "戊子", "戊午", "己丑", "己未"]
            },
            "shiling": {
                "text": "十灵日",
                "duizhao": ["甲辰", "乙亥", "丙辰", "丁酉", "戊午", "庚戌", "庚寅", "辛亥", "壬寅", "癸未"]
            },
            "rigui": {
                "text": "日贵",
                "duizhao": ["丁亥", "癸卯"]
            },
            "yegui": {
                "text": "夜贵",
                "duizhao": ["丁酉", "癸巳"]
            },
            "ride": {
                "text": "日德",
                "duizhao": ["甲寅", "戊辰", "丙辰", "庚辰", "壬戌"]
            },
            "kuigang": {
                "text": "魁罡",
                "duizhao": ["壬辰", "庚戌", "戊戌", "庚辰"]
            },
            "yinchayangcuo": {
                "text": "阴差阳错",
                "duizhao": ["丙子", "丁丑", "戊寅", "辛卯", "壬辰", "癸巳", "丙午", "丁未", "戊申", "辛酉", "壬戌", "癸亥"]
            },
            "bazhuan": {
                "text": "八专",
                "duizhao": ["甲寅", "乙卯", "己未", "丁未", "庚申", "辛酉", "戊戌", "癸丑"]
            },
            "jiuchou": {
                "text": "九丑",
                "duizhao": ["戊子", "戊午", "壬子", "壬午", "丁酉", "己酉", "己卯", "辛酉", "辛卯"]
            },
            "jinshen": {
                "text": "金神",
                "duizhao": ["癸酉", "己巳", "乙丑"]
            }
        }
    },
    "shizhu": {
        "classify": {
            "jinshen": {
                "text": "金神",
                "duizhao": ["癸酉", "己巳", "乙丑"]
            }
        }
    }
}